import React from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './features/layout/Sidebar'

export default function Layout() {
  return <div className="app-shell"><Sidebar /><main className="main-content"><Outlet /></main></div>
}
